import {
  SET_UNREAD_COUNT,
  ADD_INAPP_NOTIFICATION,
  MARK_ALL_READ,
} from "../actions/InAppNotification";

const initialState = {
  unreadCount: 0,
  latestNotification: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_UNREAD_COUNT:
      return { ...state, unreadCount: action.payload };
    case ADD_INAPP_NOTIFICATION:
      return {
        ...state,
        unreadCount: state.unreadCount + 1,
        latestNotification: action.payload,
      };
    case MARK_ALL_READ:
      return { ...state, unreadCount: 0, latestNotification: null };
    default:
      return state;
  }
};

export default reducer;
